//For cart page
// var ellmm = document.getElementsByTagName("body");
// if(ellmm[0].classList.contains("template-cart")) {
// 	document.querySelectorAll(".js-qty__wrapper .js-qty__num").forEach(function(item, index) {
// 		const event = new Event("change");
// 		item.dispatchEvent(event);
// 	});
// }

$(window).on("load resize", function() {
	//Footer accordian
	if($(window).width() <= 500) {
		$(".footer__title").unbind("click").click(function(e) {
			e.preventDefault();
			var $this = $(this);
			if($this.next().hasClass("active")) {
				$this.next().removeClass("active");
				$this.next().slideUp(350);
				$this.removeClass("active");
			} else {
				$this.parent().parent().find(".footer__block .footer__menu").removeClass("active");
				$this.parent().parent().find(".footer__block .footer__title").removeClass("active");
				$this.parent().parent().find(".footer__block .footer__menu").slideUp(350);
				$this.next().toggleClass("active");
				$this.toggleClass("active");
				$this.next().slideToggle(350);
			}
		});
	} else {
		$(".footer__title").off();
	}

    //Popup Close
	$(".cutom_popup_close").click(function() {
		$(this).parents(".custom_pop").fadeOut(150);
		$("body").removeClass("modle_open");
	});

    //Popup Open
	$(document.body).on("click", ".cutom_popup_open", function(e) {
		e.preventDefault();
		var id = $(this).attr("popup_id");
		$("#" + id).fadeIn(150);
		$("body").addClass("modle_open");
		if(id == "bold__popup_img") {
			var img_url = $(this).attr("href");
			$("#" + id).find(".number-img").attr("src", img_url);
			//       console.log(img_url);
		} else {
			var title_prod = $(this).parents(".product-grid__content").find("h1.h2.product-single__title").text().trim();
			//       console.log(title_prod,'title_prod');
			setTimeout(function() {
				$('input[name="contact[productName]"]').attr("value", title_prod);
			}, 500);
		}
	});

    //Popup redirect to url
	$(".pop_product #product_list").on("change", function() {
		$(this).parents(".custom_pop").find(".popup_go_button").attr("href", this.value);
	});

    //Toggle Shipping
	if($(window).width() <= 980) {
		$(".toogle_shipping").unbind("click").click(function(e) {
			e.preventDefault();
			var $this = $(this);
			$this.toggleClass("active");
			$this.next().slideToggle(350);
			$this.next().next().slideToggle(350);
		});
	} else {
		$(".toogle_shipping").off();
	}
});

// $(document).bind("DOMNodeInserted", function(e) {
// 	var element = e.target;
// 	var elm = $(element).attr("class");
// 	if(typeof elm != "undefined") {
// 		if(elm.indexOf("bold_option_set") > -1) {
// 			$('input[value="Returnable"]').attr("disabled", "disabled");
// 			setTimeout(function() {
// 				$('input[value="Returnable"]').attr("disabled", "disabled");
// 				$('[name="cstm-yes-no"]').removeAttr("disabled");
// 				setTimeout(function() {
// 					$('.variant-input.color_swatch[data-index="option1"] input[type=radio]').change();
// 				}, 200);
// 				setTimeout(function() {
// 					if($(".bold_option_set .bold_option_displaytext p span").text().indexOf("~ final sale") > -1) {
// 						$('[name="properties[_LPROP]"]').removeAttr("disabled");
// 					}
// 				}, 200);
// 			}, 200);
// 		}
// 	}
// });

// document.addEventListener('rebuy:smartcart.ready', updateRebuy);
// document.addEventListener('rebuy:smartcart.init', updateRebuy);
// document.addEventListener('rebuy:smartcart.show', updateRebuy);
// document.addEventListener('rebuy:cart.change', updateRebuy);
// document.addEventListener('rebuy:cart.ready', updateRebuy);

function updateRebuy(){

    if(Rebuy.SmartCart.cart && Rebuy.SmartCart.cart.items){
      let cartItems = Rebuy.SmartCart.cart.items;
      if(cartItems){
          
          cartItems.forEach(cartItem => {
              if(cartItem.properties._boldProductIds){
                  let totalBoldPrice = getTotalPrice(cartItems, cartItem.properties._boldProductIds, cartItem.properties._boldBuilderId);
                  totalBoldPrice = totalBoldPrice + cartItem.final_price;
                  cartItem.price = totalBoldPrice;
              }
          });
          
          function getTotalPrice(cartItems, products, builderID) {
            let price = 0;
            let productsArr = products.split(',').map(Number);
            cartItems.forEach(cartItem => {
                if(productsArr.includes(cartItem.product.id) && cartItem.properties._boldBuilderId == builderID){
                    price = price + cartItem.price;
                }
            });
            return price;
          }
     }
  }
  
}

$(window).ready(function() {
  
  var _intv = setInterval(function() {
    if($(".bold_options").hasClass("bold_options_loaded")) {
      $('.bold_option_displaytext').each(function(){
          let isHidden = $(this).find('.bold_help_text small').text().toLowerCase();
          if(isHidden == "hidden"){
              $(this).hide();
          }
      });
      // Delay clearing interval to ensure all elements are processed
      setTimeout(function() {
          clearInterval(_intv);
      }, 500); // 500 milliseconds delay
    }
  }, 100); // Check every 100 milliseconds

  

   //product form
  $(document).on('click','.variant-input-wrap[data-index="option1"] .variant-input',function(){
    var slect_clr = $(this).attr('data-value')
    setTimeout(function(){
      $('.unavail_option.disabled').each(function(){
        var _this = $(this);
        var size_trgt = $(this).parents('.variant-input').find('input').attr('value');
        var selected_arry = [];
        var title_trgt = slect_clr+' / '+size_trgt;
        selected_arry = listobjct.filter(function (itmm,ndx){
          return itmm.v_title==title_trgt;
        });
        if(selected_arry[0]?.v_metafield != '' && selected_arry[0]?.v_metafield != "&nbsp"){
          _this.find('.av_dte').text(selected_arry[0]?.v_metafield)
        }else{
          _this.find('.av_dte').text('Not Available')
        }
      })
    },500)
  })

  //product template
  $(document).on('click','#review_direct_link a',function(){
    e.preventDefault();
    $('html, body').animate({
      scrollTop: $("#detailed_review").offset().top - 100
    }, 1200);
  });

    //Update MPN value on variant cahnge
  document.addEventListener('variant:change', function(evt) {
    var mpn = mpnData[evt.detail.variant.sku];
    var mpnText = $(".product-single__mpn");
    var mpnValue = $(".mpn_value");
    if(mpn != null & mpn != ""){
      mpnValue.text(mpn);
      mpnText.css('display','inline-block');
      mpnValue.css('display','inline-block');
    } else{
      mpnValue.text('');
      mpnText.css('display','none');
    }
  });

  var rating = $('.oke-w-ratingAverageModule').html();
  
  if(rating){
    $('.review__header-widget').append(rating);
  }else{
    $('.review__header-widget').append('<div class="oke-w-ratingAverageModule-count">Reviews</div>');
  }

  //Cart quantity button
  // document.addEventListener("DOMContentLoaded", function() {
  //     const minusButtons = document.querySelectorAll(".js-qty__adjust--minus");
  //     const plusButtons = document.querySelectorAll(".js-qty__adjust--plus");
  
  //     minusButtons.forEach(button => {
  //       console.log('--------------');
  //         button.addEventListener("click", function(e) { e.preventDefault();
  //             const variantId = getVariantId(button);
  //             const quantityElement = button.parentElement.querySelector('.js-qty__num');
  //             let quantity = parseInt(quantityElement.textContent);
  //             if (quantity > 0) {
  //                 quantity--;
  //                 quantityElement.textContent = quantity;
  //                 updateCartItemQuantity(variantId, quantity);
  //             }
  //         });
  //     });
  
  //     plusButtons.forEach(button => {
  //       console.log('+++++++++++++++++');
  //         button.addEventListener("click", function(e) { e.preventDefault();
  //             const variantId = getVariantId(button);
  //             const quantityElement = button.parentElement.querySelector('.js-qty__num');
  //             let quantity = parseInt(quantityElement.textContent);
  //             quantity++;
  //             quantityElement.textContent = quantity;
  //             updateCartItemQuantity(variantId, quantity);
  //         });
  //     });
  
  //     function getVariantId(button) {
  //         let parent = button.parentElement;
  //         while (parent && !parent.classList.contains('cart__item')) {
  //             parent = parent.parentElement;
  //         }
  //         if (parent) {
  //             const dataKey = parent.getAttribute('data-key');
  //             const parts = dataKey.split(':');
  //             if (parts.length > 0) {
  //                 return parts[0];
  //             }
  //         }
  //         return null;
  //     }
  
  //     function updateCartItemQuantity(variantId, quantity) {
  //         const formData = new FormData();
  //         formData.append('id', variantId);
  //         formData.append('quantity', quantity);
          
  //         fetch('/cart/change.js', {
  //         method: 'POST',
  //         body: formData
  //         })
  //         .then(response => response.json())
  //         .then(data => console.log(data))
  //         .catch(error => console.error('Error:', error));
  //     }
  // });
  
  if(window.combination) {
    $.each(combination, function(key, value) {
      $("select#product_list option").each(function() {
        var title = $(this).text();
        var short = "(" + key + ")";
        if(title.indexOf(short) > -1) {
            var newTitle = value + " " + short;
            $(this).text(newTitle);
        }
      });
    });
  }

  
	// setTimeout(function() {
		// $('.variant-input-wrap[name="width"] input:checked').trigger("change");
		//     $('.bold-options-container input,.bold-options-container select').attr('disabled','disabled');
		// $('[name="properties[_LPROP]"]').attr("disabled", "disabled");
	// }, 300);
	//   $(document).on('change','.variant-input-wrap[name="width"] input',function(){
	//     let width = $(this).val();
	//     console.log('name="properties[Return Policy]"')
	//     if(width == 'EE - Wide'){
	//       $('.variant-input[data-index="option1"]').each(function(){
	//         let dataValue = $(this).attr('data-value');
	//         if(dataValue.indexOf('EE') > -1){
	//           $(this).addClass('ee-variant')
	//           $(this).css('display','inline-block');
	//         }else{
	//           $(this).hide();
	//         }
	//       });
	//       var redElements = document.querySelectorAll('.ee-variant');
	//       var first = redElements[0];
	//       $(first).find('label').trigger('click');
	//     }else{
	//       $('.variant-input[data-index="option1"]').each(function(){
	//         let dataValue = $(this).attr('data-value');
	//         if(dataValue.indexOf('EE') > -1){
	//           $(this).hide();
	//         }else{
	//           $(this).addClass('not-ee-variant')
	//           $(this).css('display','inline-block');
	//         }
	//       });
	//       var redElements = document.querySelectorAll('.not-ee-variant');
	//       var first = redElements[0];
	//       $(first).find('label').trigger('click');
	//     }
	//   });
	//   $(document).on('DOMNodeInserted', function(e) {
	//     if ( $(e.target).hasClass('bold_option_radio') )
	//     {
	//       $('[name="properties[Return Policy]"]').attr('disabled','disabled');
	//     }
	//   });
	// function boldOtionsCode(val, lprop) {
	// 	$(".bold_option_displaytext").hide();
	// 	console.log(val);
	// 	$("#lprop").val(lprop);
	// 	if(val == "Returnable") {
	// 		$('.bold_option_set input[value="Returnable"]').removeAttr("disabled");
	// 		$('[name="properties[Return Policy]"][value="' + val + '"]').trigger("click");
	// 		$('[name="properties[Return Policy]"]:checked').trigger("click");
	// 		$('.bold-options-container [value="Returnable"]').trigger("click");
	// 		$('[name="properties[Return Policy]"]').attr("disabled", "disabled");
	// 		$('[name="properties[_LPROP]"]').attr("disabled", "disabled");
	// 		if($(".variant-input[data-index='option1'] input[type=radio][name='Color']:checked").length > 0) {
	// 			$(".bold-options-container input,.bold-options-container select").attr("disabled", "disabled");
	// 		}
	// 		$(".is-current").hide();
	// 	} else {
	// 		$('.bold-options-container [value="final sale"]').trigger("click");
	// 		$('.bold_option_set:not(:hidden) [name="properties[Return Policy]"]').removeAttr("disabled");
	// 		$('#lprop[name="properties[_LPROP]"]').removeAttr("disabled");
	// 		$('.bold_option_set:not(:hidden) [name="properties[Return Policy]"][value="' + val + '"]').trigger("click");
	// 		$('.bold_option_set:not(:hidden) [name="properties[Return Policy]"]:checked').trigger("click");
	// 		$(".is-current").show();
	// 		$('#lprop[name="properties[_LPROP]"]').removeAttr("disabled");
	// 		setTimeout(function() {
	// 			$(".bold-options-container input,.bold-options-container select").removeAttr("disabled");
	// 			$('.bold_option_set input[value="Returnable"]').attr("disabled", "disabled");
	// 			$('.bold_option_set.is-current input[value="Returnable"]').removeAttr("disabled");
	// 		}, 500);
	// 	}
	// 	show_related_option();
	// }
	// $(".cstm-yes-no-options input").on("click", function() {
	// 	var val = $(this).val();
	// 	var lprop = $(this).data("value");
	// 	boldOtionsCode(val, lprop);
	// });
	// $(document).on("change", '.bold_option_element select[name="properties[Would you like to add an American flag patch?]"]', function() {
	// 	var val = $(this).val();
	// 	var lprop = $(this).data("value");
	// 	if(val == "No") {
	// 		val = "Returnable";
	// 		lprop = "Exchange Only";
	// 	} else {
	// 		val = "final sale";
	// 		lprop = "final sale";
	// 	}
	// 	boldOtionsCode(val, lprop);
	// });
	//   $('body').one('DOMNodeInserted','.bold_options.bold_options_loaded', function(e) {
	//     console.log('------------------------------============================')
	//     if($('body').find('.bold_options.bold_options_loaded').length > 0){
	//       $('.bold-options-container').append($('.bold_options.bold_options_loaded'));
	//     }
	//   });
	// $("body").on("change", '.variant-input.color_swatch[data-index="option1"] input[type=radio]', function() {
	// 	$('#c-no[name="cstm-yes-no"]').trigger("click");
	// 	show_related_option();
	// });

	// function show_related_option() {
	// 	if($(".variant-input[data-index='option1'] input[type=radio][name='Color']:checked").length > 0) {
	// 		var color = $(".variant-input[data-index='option1'] input[type=radio]:checked").next().next().text();
	// 		color = color.trim();
	// 		if($('.logic-color-bold-option[data-color="' + color + '"]').length > 0) {
	// 			$(".bold-options-container input,.bold-options-container select").attr("disabled", "disabled");
	// 			let option = $('.logic-color-bold-option[data-color="' + color + '"]').attr("data-option");
	// 			//         $('.bold_option_set input').attr('disabled','disabled');
	// 			setTimeout(function() {
	// 				$(".bold_option_set").each(function() {
	// 					if($(this).find(".bold_option_displaytext").find(".bold_option_element").find("span").length > 0) {
	// 						let option_check = $(this).find(".bold_option_displaytext").find(".bold_option_element").find("span").text();
	// 						if(option_check.includes(option)) {
	// 							$(this).find(".bold_option_displaytext").hide();
	// 							$(this).addClass("is-current");
	// 							if($(".cstm-yes-no-options input:checked").val() == "final sale") {
	// 								$(".bold-options-container").show();
	// 								$(this).show();
	// 								$('.bold-options-container [value="Returnable"]').trigger("click");
	// 								$(this).find('[value="final sale"]').trigger("click");
	// 								$(this).find("input,select").removeAttr("disabled");
	// 								$(this).children().first().find('input[value="final sale"]').trigger("click");
	// 							} else {
	// 								$(".bold-options-container input,.bold-options-container select").attr("disabled", "disabled");
	// 								$(".bold-options-container").hide();
	// 							}
	// 						} else {
	// 							$(this).hide();
	// 							$(this).removeClass("is-current");
	// 						}
	// 					}
	// 				});
	// 			}, 300);
	// 		}
	// 	}
	// }
	// show_related_option();
	//   setTimeout(function(){
	//     $('[data-index="option1"] input:checked').trigger('change');
	//     //     $('[name="properties[Return Policy]"]').attr('disabled','disabled');
	//     $('.bold_option_displaytext').hide();
	//   },3000);


  
	$('fieldset.variant-input-wrap[data-handle="fit-type"] input , fieldset.variant-input-wrap[data-handle="width"] input').on("change", function() {
		 hideUnAvailable();
	});

  
	// $(document).on("change", ".bold-options-container input,.bold-options-container select,.cstm-yes-no-options input", function() {
	// 	$(".bold_option_set .bold_option_title").css("opacity", 0);
	// 	setTimeout(function() {
	// 		$(".bold_option_set .bold_option_title").each(function() {
	// 			let count = $(".bold_option_set").length;
	// 			for(let i = 1; i <= count; i++) {
	// 				$(this).text($(this).text().replace(" " + i, ""));
	// 			}
	// 			$(this).css("opacity", 1);
	// 		});
	// 	}, 10);
	// });
	

	//Open klaviyo sms sign up popup
	const openSMSPopup = document.querySelectorAll(".signup-for-sms, #get-texts");
	for(let i = 0; i < openSMSPopup.length; i++) {
		openSMSPopup[i].addEventListener("click", function(e) {
			e.preventDefault();
			var _klOnsite = window._klOnsite || [];
			_klOnsite.push(["openForm", "SspQfq"]);
		});
	}
});

    function  hideUnAvailable(){
        let val = $('fieldset.variant-input-wrap[data-handle="fit-type"] input:checked').val() || $('fieldset.variant-input-wrap[data-handle="width"] input:checked').val();
		let optionvalue1 = $('fieldset.variant-input-wrap[data-handle="fit-type"] .variant-input').attr("data-position") || $('fieldset.variant-input-wrap[data-handle="width"] .variant-input').attr("data-position");
		let optionvalue2 = $('fieldset.variant-input-wrap[data-handle="size"] .variant-input').attr("data-position");
      
        if(optionvalue1 && optionvalue2){
    		$('fieldset.variant-input-wrap[data-handle="size"] .variant-input ').hide();
    		$(".product-single__variants option").each(function(i, v) {
    			let label = $(this).text();
    			let option_one = optionvalue1 ? label.split(" / ")[optionvalue1].trim() : null;
    			if(option_one && val == option_one) {
    				let option_two = label.split(" / ")[optionvalue2].split("-")[0].trim();
    				$('fieldset.variant-input-wrap[data-handle="size"] .variant-input[data-value="' + option_two + '"]').show();
    			}
    		});
    		$('.variant-input[data-index="option2"]:not(:hidden) input:checked').prop("checked", true);
        }
      
    }

// $(window).on("load resize",function(e){
//   if($(window).innerWidth() < 959){
//     if($('.sub_collect_hedr .new-grid.scrollable-grid--small').length > 0){
//       $('.sub_collect_hedr .new-grid.scrollable-grid--small').slick({
//         slidesToShow: 1.5,
//         slidesToScroll: 1,
//         infinite: false,
//         dots: true,
//         arrows:false
//       });
//     }
//   }else{
//     if($('.sub_collect_hedr .new-grid.scrollable-grid--small').hasClass( "slick-initialized" )){
//       $('.sub_collect_hedr .new-grid.scrollable-grid--small').slick('unslick');
//     }
//   }
// });


//Mobile sticky cart button
$(document).on("click", ".cart_mobile_sticky_right .cart__checkout.custon_checkout", function() {
	$(".checkout_bttn button.btn.cart__checkout").click();
});

//Mobile cart tabs
$(document).ready(function() {
  hideUnAvailable();
	$(".cart_mobile_tab").click(function() {
		$(".tabs_details").removeClass("tab-active");
		$(".tabs_details[id='" + $(this).attr("tab-id") + "']").addClass("tab-active");
		$(".cart_mobile_tab").removeClass("active");
		$(this).addClass("active");
	});
	$("body").on("click", ".close-cart", function(e) {
		if(window.location.href == document.referrer) {
			window.location.href = "/";
		} else {
			window.location.href = document.referrer;
		}
	});
});

function addyesno(){
  $(".bold_option.bold_option_radio").each(function(){
      let c = 0;
      $(this).find('.bold_option_value').each(function(){
          let val = $(this).find('input').val().trim();
          if(val == 'Yes') c = c + 1;
          if(val == 'No') c = c + 1;
      });
      if(c == 2){
          $(this).addClass('yes-no-options');
      }
  });
}

BOLD.common.eventEmitter.on('', function(event) {
  addyesno();
});

BOLD.common.eventEmitter.on('BOLD_OPTIONS_option_changed', function(event) {
  addyesno();
});


$(document).ready(function() {
  addyesno();
  let arrrrr = theme.strings.themeQuestions.split(',');
  
  $(document).on('click','.bold_option_radio', function(){
      let label = $(this).find('.bold_option_title').text().trim();
      if(arrrrr.includes(label)){
        let val = $(this).find('[type="radio"]:checked').val().trim();
        if(val == "Yes"){
          $('[name="properties[_LPROP]"]').removeAttr("disabled");
          $('[name="properties[SHWKFLW]"]').removeAttr("disabled");
        }else{
          $('[name="properties[_LPROP]"]').attr("disabled", "disabled");
          $('[name="properties[SHWKFLW]"]').attr("disabled", "disabled");
        }
      }
  });

  $(document).on('change','.yes-no-options input', function(){
    $(this).parents('.yes-no-options').addClass('selected');
    $(this).parents('.yes-no-options').find('.bold_option_value').removeClass('selected-val');
    $(this).parents('.bold_option_value').addClass('selected-val');
  });



	// var isLoaded = false;
	// var _intv = setInterval(function() {
	// 	if($(".bold_options").hasClass("bold_options_loaded") && isLoaded == false) {
	// 		isLoaded = true;
	// 		setTimeout(function() {
	// 			$('[data-handle="fit-type"] input:checked').trigger("change");
	// 			$('[data-handle="width"] input:checked').trigger("change");
	// 			$(".bold_option_displaytext").hide();
	// 		}, 1200);
	// 	} else if(!$(".bold_options").hasClass("bold_options_loaded") && isLoaded == true) {
	// 		isLoaded = false;
	// 	}
	// }, 500);
  
	// BOLD.options.app.on("total_changed", function(evt) {
	// 	let productPrice = evt.data.option_product.priceHandler.productPrice;
	// 	let boldOptionprice = evt.data.total;
	// 	let newProductprice = productPrice + boldOptionprice;
	// 	let rewardAmount = newProductprice * 0.05;
	// 	document.getElementById("rewardsamount").innerHTML = theme.Currency.formatMoney(rewardAmount, theme.settings.moneyFormat);
	// 	document.getElementById("rewards_points").innerHTML = Math.ceil(newProductprice / 100);
	// });


  //Rewards on PDP
    const targetDiv = document.querySelector('.price-meta');
  
    if(targetDiv){
      const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
              const childSpan = targetDiv.querySelector('.product__price > span');
              if (childSpan) {
                  let newPrice = unformatPrice(childSpan.textContent);
                  let rewardAmount = newPrice * 0.05;
                  document.getElementById("rewardsamount").innerHTML = theme.Currency.formatMoney(rewardAmount, theme.settings.moneyFormat);
              	document.getElementById("rewards_points").innerHTML = Math.ceil(newPrice / 100);
              }
          });
      });
      
      const config = { childList: true, subtree: true };
      observer.observe(targetDiv, config);
    }
    
    
    function unformatPrice(formattedPrice) {
        var unformattedPrice = formattedPrice.replace(/[^\d]/g, '');
        return parseInt(unformattedPrice, 10);
    }

    //Collection description read more/less
	if($(".collection_desc").length) {
		let colDesc = $(".collection_desc").html();
		let desc_lines = colDesc.split(".");
		let pre_readmore = [];
		if(desc_lines.length > 1) {
			$.each(desc_lines, function(index, value) {
				if(value.trim() != "") {
					if(window.outerWidth <= 768 && index <= 1) {
						pre_readmore.push(value);
					} else if(window.outerWidth >= 768 && index <= 2) {
						pre_readmore.push(value);
					}
				}
			});
			$(".collection_desc").html('<div class="pretext"></div><div class="moretext"></div><a class="more_btn" href="#">Read More</a>');
			$.each(pre_readmore, function(index, value) {
				$(".collection_desc .pretext").append(value + ".");
			});
			$.each(desc_lines, function(index, value2) {
              console.log(value2)
				if(index >= pre_readmore.length && value2.trim() != "") {
					$(".collection_desc .moretext").append(value2 + ".");
				}
				if(value2.trim() == "") desc_lines.splice(index, 1);
			});
			if(window.outerWidth <= 768) {
				if(desc_lines.length <= 2) {
					$(".more_btn").hide();
				}
			} else if(window.outerWidth >= 768) {
				if(desc_lines.length <= 3) {
					$(".more_btn").hide();
				}
			}
			$(".collection_desc").show();
		}
	}
	$(document).on("click", ".collection_desc a.more_btn", function(e) {
		e.preventDefault();
		if($(".collection_desc").hasClass("active")) {
			$(".collection_desc").removeClass("active");
			$(".moretext").slideUp();
			$(this).text("Read More");
		} else {
			$(".collection_desc").addClass("active");
			$(".moretext").slideDown({
				end: function() {
					$(this).css({
						display: "inline",
					});
				},
			});
			$(this).text("Read Less");
		}
	});
	$(document).on("click", "button#filters_and_Sort_toggle", function(e) {
		e.preventDefault();
		$(".filter-wrapper").addClass("active");
	});
	$(document).on("click", "span.close_filter", function(e) {
		e.preventDefault();
		$(".filter-wrapper").removeClass("active");
	});
});

document.addEventListener("ajaxProduct:added", function(evt) {
	console.log(evt.detail.product);
	// if addToCartBtn is returned, product was added by quick add feature
	if(evt.detail.addToCartBtn) {
		console.log(evt.detail.addToCartBtn);
	}
});

$(document).on("click", ".variant-input-wrap .variant-input", function() {
	$(this).parents(".variant-wrapper").find("[data-variant-color-label]").text($(this).find("input:checked").val());
});

$(document).on("click", ".logo-filter-list .checkmark", function() {
	$(this).parents(".logo-filter-list").find('input[type="checkbox"]').trigger("click");
});

$(document).ready(function() {
  if($(window).innerWidth() < 768) {
    $(".desktop-title .product___policies").html($(".shopify-payment-terms.product__policies"));
    $(".form_controller").after($(".rewards_points"));
  }
});


// Product Recieved by custom code
// var elemToObserve = document.querySelector(
//   ".product-stock-label .product-block--sales-point"
// );
// var prevClassState = elemToObserve.classList.contains("hide");
// var observer = new MutationObserver(function (mutations) {
//   mutations.forEach(function (mutation) {
//     if (mutation.attributeName == "class") {
//       var currentClassState = mutation.target.classList.contains("hide");
//       if (prevClassState !== currentClassState) {
//         prevClassState = currentClassState;
//         if (currentClassState)
//           document.querySelector(".need_it_fast").classList.add("hide");
//         else document.querySelector(".need_it_fast").classList.remove("hide");
//       }
//     }
//   });
// });
// observer.observe(elemToObserve, { attributes: true });


//Get product price for mobile devices on PDP 
var productPrice = jQuery('.pdp_single_price.small--hide').html();
jQuery('.pdp_single_price.medium-up--hide').append(productPrice);
document.addEventListener('variant:change', function(evt) {
  setTimeout(function() {
    jQuery('.pdp_single_price.medium-up--hide').empty();
    var productPrice1 = jQuery('.pdp_single_price.small--hide').html();
    jQuery('.pdp_single_price.medium-up--hide').append(productPrice1);
  }, 100);
});


//Show Live chat button based on the business hours
if($(".dynamic_chat_button").length > 0){
  const targetTimeZone = 'America/Chicago'; // Central Time
  const businessHoursStart = 8; // Business hours start at 8 AM
  const businessHoursEnd = 16; // Business hours end at 4 PM

  function isBusinessHours(currentTime) {
    const currentHour = currentTime.getHours();
    return currentHour >= businessHoursStart && currentHour < businessHoursEnd;
  }

  function showStatusMessage() {
    // Get the current date and time in the target time zone
    const currentTime = new Date().toLocaleString('en-US', { timeZone: targetTimeZone });

    // Check if it's business hours
    const isInBusinessHours = isBusinessHours(new Date(currentTime));

    // Display the status message based on business hours
    if (isInBusinessHours) {
      $(".dynamic_chat_button").text("Available").attr('id','available');
    } else {
      $(".dynamic_chat_button").text("Unavailable").attr('id','unavailable');
    }
  }

  // Initial status check
  showStatusMessage();

  // Update the status every minute
  setInterval(showStatusMessage, 60000);
}

document.addEventListener('rebuy:cart.add', (event) => { 
  $('[data-add-to-cart]').removeClass('.btn--loading');
});
document.addEventListener('rebuy:cart.change', (event)=> {
  setTimeout(() => {
  const cartItems = Rebuy.SmartCart.items();
  const filteredData = cartItems.filter(item => !item.product.tags.includes('bold_hidden_product'));
  
  console.log(filteredData.length); // This will log the filtered items without "bold_hidden_product"
  var countEls = document.querySelectorAll('.cart-link__bubble-num');
  
        if (countEls.length) {
          countEls.forEach(el => {
            el.innerText = filteredData.length;
          });
        }

  }, 500);

})
// Open Missive Chat on button click
$(document).on('click','#available, .live-chat, .self-service-help-center', function(){
  if (window.MissiveChat) {
    window.MissiveChat.open();
  }
});
